<template>
	<div class="virtual-v-data-table">
		<div class="table-header">
			<template v-for="header in headers">
				<div class="header cell primary--text" :key="header.name">
					{{ header.name }}
				</div>
			</template>
		</div>
		<v-divider></v-divider>

		<v-virtual-scroll class="v-virtual-scroll" :bench="4" :items="items" item-height="48">
			<template #default="{ item }">
				<div class="table-row">
					<div
						class="item-row cell"
						:style="'text-align:' + header.align"
						v-for="(header, index) in headers"
						:key="index"
					>
						<slot :name="'item.' + header.value" :item="item">
							<span> {{ item[header.value] }}</span>
						</slot>
					</div>
				</div>
				<v-divider></v-divider>
			</template>
		</v-virtual-scroll>
	</div>
</template>
<script>
export default {
	name: 'virtual-v-data-table',
	props: {
		headers: {
			type: Array,
			default: () => [],
		},
		items: {
			type: Array,
			default: () => [],
		},
	},
}
</script>

<style lang="stylus" scoped>
.cell {
	flex: 1;
	padding: 0 16px
}

.table-header,
.table-row {
	display: flex;
	align-items: center;
	height: 40px;
	box-sizing: border-box;
}

.header {
	font-weight: bold;
}
.v-virtual-scroll {
	min-height: 100px;
	max-height: 250px;
}
::-webkit-scrollbar {
	width: 4px;
}
::-webkit-scrollbar-track {
	border-radius: 10px;
}
::-webkit-scrollbar-thumb {
	background: #7f7f7f96;
	border-radius: 10px;
}
</style>
